import React from 'react';
import NotificationFallback from '../utils/notificationFallback';

const NotificationFallbackTestPage: React.FC = () => {
  const handleTestToast = (type: 'info' | 'warning' | 'error' | 'success') => {
    NotificationFallback.showToast({
      title: `Test ${type.charAt(0).toUpperCase() + type.slice(1)} Toast`,
      message: `Đây là một thông báo test kiểu ${type}. Nó sẽ tự động biến mất sau 5 giây hoặc bạn có thể click để đóng.`,
      type,
      duration: 5000
    });
  };

  const handleTestNotify = () => {
    NotificationFallback.notify({
      title: 'Test Smart Notification',
      message: 'Hệ thống sẽ tự động chọn browser notification hoặc toast dựa trên khả năng hỗ trợ.',
      type: 'info'
    });
  };

  const handleClearAll = () => {
    NotificationFallback.clearAll();
  };

  const isNotificationSupported = NotificationFallback.isNotificationSupported();

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>🧪 Notification Fallback Test</h1>
      
      <div style={{ 
        padding: '16px', 
        borderRadius: '8px', 
        backgroundColor: isNotificationSupported ? '#e8f5e8' : '#fff3e0',
        border: `1px solid ${isNotificationSupported ? '#4caf50' : '#ff9800'}`,
        marginBottom: '20px'
      }}>
        <h3>Trạng thái hỗ trợ Notification:</h3>
        <p>
          {isNotificationSupported ? (
            <span style={{ color: '#4caf50' }}>✅ Trình duyệt hỗ trợ Notification API</span>
          ) : (
            <span style={{ color: '#ff9800' }}>⚠️ Trình duyệt KHÔNG hỗ trợ Notification API</span>
          )}
        </p>
        
        {typeof window !== 'undefined' && (
          <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
            <div>• Notification in window: {'Notification' in window ? '✅' : '❌'}</div>
            <div>• ServiceWorker in navigator: {'serviceWorker' in navigator ? '✅' : '❌'}</div>
            <div>• Notification permission: {Notification?.permission || 'N/A'}</div>
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', marginBottom: '20px' }}>
        <button 
          onClick={() => handleTestToast('info')}
          style={{
            padding: '12px 16px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: '#2196F3',
            color: 'white',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Test Info Toast
        </button>
        
        <button 
          onClick={() => handleTestToast('success')}
          style={{
            padding: '12px 16px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: '#4CAF50',
            color: 'white',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Test Success Toast
        </button>
        
        <button 
          onClick={() => handleTestToast('warning')}
          style={{
            padding: '12px 16px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: '#FF9800',
            color: 'white',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Test Warning Toast
        </button>
        
        <button 
          onClick={() => handleTestToast('error')}
          style={{
            padding: '12px 16px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: '#f44336',
            color: 'white',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Test Error Toast
        </button>
      </div>

      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
        <button 
          onClick={handleTestNotify}
          style={{
            padding: '12px 16px',
            borderRadius: '6px',
            border: '2px solid #2196F3',
            backgroundColor: 'transparent',
            color: '#2196F3',
            cursor: 'pointer',
            fontSize: '14px',
            flex: 1
          }}
        >
          Test Smart Notification
        </button>
        
        <button 
          onClick={handleClearAll}
          style={{
            padding: '12px 16px',
            borderRadius: '6px',
            border: '2px solid #f44336',
            backgroundColor: 'transparent',
            color: '#f44336',
            cursor: 'pointer',
            fontSize: '14px',
            flex: 1
          }}
        >
          Clear All Toasts
        </button>
      </div>

      <div style={{ 
        padding: '16px', 
        borderRadius: '8px', 
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd'
      }}>
        <h3>Hướng dẫn test:</h3>
        <ul style={{ marginLeft: '20px', lineHeight: '1.6' }}>
          <li><strong>Toast Tests:</strong> Test các loại toast notifications với các màu sắc và icon khác nhau</li>
          <li><strong>Smart Notification:</strong> Tự động chọn browser notification hoặc toast tùy thuộc vào khả năng hỗ trợ</li>
          <li><strong>Clear All:</strong> Xóa tất cả toast notifications đang hiển thị</li>
          <li>Toast sẽ tự động biến mất sau 5 giây hoặc click để đóng thủ công</li>
          <li>Hover vào toast để xem hiệu ứng animation</li>
        </ul>
      </div>
    </div>
  );
};

export default NotificationFallbackTestPage;
